import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { getPanelCount } from '_helpers';
import { PatientCareCenterNoteObjectiveNeuroTone } from './Tone';
import { PatientCareCenterNoteObjectiveNeuroReflexes } from './Reflexes';
import { PatientCareCenterNoteObjectiveNeuroAsymmetries } from './Asymmetries';
import { PatientCareCenterNoteObjectiveNeuroSynergies } from './Synergies';
import { PatientCareCenterNoteObjectiveNeuroProprioception } from './Proprioception';
import { PatientCareCenterNoteObjectiveNeuroBodyAwareness } from './BodyAwareness';
import { PatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation } from './SensoryProcessingModulation';


class PatientCareCenterNoteObjectiveNeuro extends React.Component {

    render() {

        return (
            <PatientCareCenterNoteSection id='obj_nero' name='Neuro' level={1}>
                {this.props.isPeds && this.props.isPedsEnabled &&
                    <>
                        <PatientCareCenterNoteObjectiveNeuroReflexes />
                        <PatientCareCenterNoteObjectiveNeuroAsymmetries />
                        <PatientCareCenterNoteObjectiveNeuroSynergies />
                        <PatientCareCenterNoteObjectiveNeuroProprioception />
                        <PatientCareCenterNoteObjectiveNeuroBodyAwareness />
                        <PatientCareCenterNoteObjectiveNeuroSensoryProcessingModulation />
                         <PatientCareCenterNoteObjectiveNeuroTone /> 
                    </>
                }
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;

    return {
        noteId: noteId,
        panelCount: getPanelCount(noteId, 'Observation'),
        isPeds: isPeds,
        isPedsEnabled: isPedsEnabled
    };
}

const connectedPatientCareCenterNoteObjectiveNeuro = connect(mapStateToProps)(PatientCareCenterNoteObjectiveNeuro);
export { connectedPatientCareCenterNoteObjectiveNeuro as PatientCareCenterNoteObjectiveNeuro };